import { request } from "react-rb/request"

/**
 * Updates the account's brand settings.
 *
 * @param {Object} params
 * @param {string} params.faviconUrl - The favicon URL to save on the brand
 * @return {Promise<Object>} The updated brand attributes
 */
export async function updateBrand({ faviconUrl }) {
  const response = await request("/account/brand", {
    method: "PUT",
    data: { brand: { favicon_url: faviconUrl } }
  })
  if (!response.ok) throw response
  return response.data
}

export async function fetchBrandColors() {
  const response = await request("/account/color_settings", { method: "GET" })
  if (!response.ok) throw response
  return response.data.colors
}

export async function updateBrandColors(colors) {
  const response = await request("/account/color_settings", {
    method: "PUT",
    data: { colors_settings: { colors } }
  })
  if (!response.ok)
    throw new Error(response.data?.errors || "Couldn't save colors")
  return response.data.colors
}
